import React, { useState, useEffect } from 'react';
import Section from './Section';

const members = [
  {
    name: 'FERNANDO BARNABÉ',
    role: 'Presidente da AEAGO',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/fernando-batore.jpg'
  },
  {
    name: 'ONILDA ALBUQUERQUE',
    role: 'Vice-presidente',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/onilda-alburqueque.jpg'
  },
  {
    name: 'MARCELO CORTE',
    role: 'Secretário Geral',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Marcelo.jpeg'
  },
  {
    name: 'ANNIBAL MARGON',
    role: 'Diretor de Finanças',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/annibal-margon.jpg'
  },
  {
    name: 'ANTÔNIO PASQUALETTO',
    role: 'Subdiretor de Finanças',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Antonio.jpeg'
  },
  {
    name: 'ANNA CARLA SOUZA',
    role: 'Diretora de Administração',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/ana-carla.jpg'
  },
  {
    name: 'GUIDO JULIANO',
    role: 'Diretor de Documentação e Divulgação',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/guido-juliano.jpg'
  },
  {
    name: 'LAURA BERNARDINO',
    role: 'Diretora de Interior',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Laura-Bernardino.jpeg'
  },
  {
    name: 'GUILHERME QUAGLIOZ',
    role: 'Subdiretor de Interior',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/gilherme-quaglioz.jpg'
  },
  {
    name: 'DANIELA RÉZIO',
    role: 'Conselheira Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Daniela.jpeg'
  },
  {
    name: 'FLÁVIA RABELO',
    role: 'Conselheira Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/flavia-rabelo.jpg'
  },
  {
    name: 'IRUMUARA INTERAMINENSE',
    role: 'Conselheiro Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Irumuara.jpeg'
  },
  {
    name: 'JOSÉ DE SOUZA REIS',
    role: 'Conselheiro Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Jose-Reis.jpeg'
  },
  {
    name: 'LUIZ HENRIQUE SILVA',
    role: 'Conselheiro Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/Luiz.jpeg'
  },
  {
    name: 'ROGÉRIO DE ARAÚJO',
    role: 'Conselheiro Fiscal',
    term: 'Gestão 2025/2026',
    img: '/imagem/diretoria/rogerio-almeida.jpg'
  },
];

const commissions = [
  {
    title: 'Comissão de Arborização Urbana AEAGO',
    members: [
      'Andrei Pereira Oliveira',
      'Annibal Lacerda Margon',
      'Antônio Pasqualeto',
      'Fabíola Adaiane',
      'Fernanda Simão Souza',
      'Marise Faleiro',
      'Onilda Arantes Albuquerque'
    ]
  },
  {
    title: 'Comissão de Meio Ambiente AEAGO',
    members: [
      'Andrei Pereira Oliveira',
      'Bento de Godoy Neto',
      'Esther Siqueira de Deus',
      'Fernando Henrique de Godoy',
      'José Ernesto Nigri Santos Silva',
      'Laura Bernardino Fernandes Giroldo',
      'Leandro Teles e Lemes',
      'Márcio Sena Pinto',
      'Onilda Arantes Albuquerque',
      'Otacílio Ferreira de Paiva Júnior',
      'Raniel Roberto Cunha Vilefort',
      'Thiago Castro de Oliveira',
      'Victor Hugo Martins De Jesus',
      'Yasmim Gabriely Vieira'
    ]
  },
  {
    title: 'Comissão de Hub, Startups e Tecnologia (AgroHub AEAGO)',
    members: [
      'Andrei Pereira Oliveira',
      'Filipe de Sousa Ferreira',
      'Murilo Morais Monteiro',
      'Victor de Sousa Ferreira'
    ]
  },
  {
    title: 'Comissão do Vale do Araguaia AEAGO',
    members: [
      'Estênio Moreira Alves',
      'Igor de Paula Marques Gonçalves',
      'Kesley Cássio Dias Guimarães',
      'Lucas Marciano Relva',
      'Lucas Mendes Rodrigues',
      'Márcio Sena Pinto',
      'Milton Ferreira de Moraes',
      'Rodrigo Reis Cruz Xaveiro'
    ]
  },
  {
    title: 'Comissão de Crédito Rural AEAGO',
    members: [
      'Cássio da Silva Kran',
      'Daniel José Mendes',
      'Fauze Machado Makhoul Hanna',
      'Guilherme Quaglioz Costa',
      'José Renato Catarina Ribeiro',
      'Leonardo de Oliveira Machado',
      'Lucas Mendes Rodrigues',
      'Magno Victor Alves Cardoso',
      'Robledo Soares Soyer',
      'Thâmara de Mendonça Guedes Kran',
      'Velma Lúcia Tavares Silva'
    ]
  },
  {
    title: 'Comissão Agro Delas AEAGO',
    members: [
      'Alzirene de Vasconcelos Milhomem',
      'Bruna de Souza Bites Barbosa',
      'Cicera Maria Lucindo',
      'Eryka Aveliny Soares Cabral',
      'Esther Siqueira de Deus',
      'Fabiana Rocha Mendonça',
      'Flávia Rabelo Barbosa',
      'Gabryela Rocha Pessoa',
      'Luíla Macêdo Lemes',
      'Mônica Coimbra Rocha',
      'Tatiana Agostinho',
      'Tatiane Mesquita Vaz',
      'Tatiele Bento de Bastos Santos',
      'Tauanne Rodrigues de Souza',
      'Thâmara de Mendonça Guedes Kran',
      'Yasmim Gabriely Vieira',
      'Marcela Carolina de Oliveira Peixoto'
    ]
  }
];

const departments = [
  {
    title: 'Departamento de Atividades Sociais',
    members: [
      'Geiser Gomes Martins',
      'Sérgio Barbosa',
      'Marcus Writher',
      'Lucas Amaro Vieira'
    ]
  },
  {
    title: 'Departamento de Política Profissional',
    members: [
      'José Antônio da Silva Netto',
      'Matheus Alves Cadete',
      'Thiago Castro de Oliveira'
    ]
  },
  {
    title: 'Departamento Técnico-Científico',
    members: [
      'Milton Ferreira de Moraes',
      'Estenio Moreira Alves',
      'Carlos Eduardo Bento Barbosa'
    ]
  },
  {
    title: 'Representantes da AEAGO no Conselho Estadual de Segurança Alimentar e Nutricional - Conesan da Secretaria de Agricultura',
    members: [
      'Rodrigo Reis Cruz Xaveiro',
      'Cássio da Silva Kran'
    ]
  }
];

const InfoGroup = ({ title, items }) => (
  <div className="bg-white rounded-2xl shadow-md border border-blue-100 flex flex-col h-[520px] sm:h-[580px]">
    <h3 className="text-navy text-lg sm:text-xl font-bold px-5 sm:px-6 pt-5 sm:pt-6 pb-4 border-b border-blue-100 flex-shrink-0">
      {title}
    </h3>

    <div className="overflow-y-auto flex-1 p-5 sm:p-6">
      <div className="space-y-4">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="bg-blue-50/70 rounded-xl p-4 border border-blue-100"
          >
            <h4 className="text-navy font-semibold text-sm sm:text-base mb-2 leading-snug">
              {item.title}
            </h4>

            <ul className="space-y-1.5">
              {item.members.map((member, i) => (
                <li
                  key={i}
                  className="text-sm sm:text-[15px] text-gray-700 leading-relaxed"
                >
                  • {member}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const Diretorias = () => {
  const [index, setIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    const getCount = () => {
      if (window.innerWidth < 640) return 1;
      if (window.innerWidth < 1024) return 2;
      return 3;
    };

    const handler = () => setVisibleCount(getCount());
    handler();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % members.length);
    }, 9000);
    return () => clearInterval(interval);
  }, []);

  const prev = () => {
    setIndex((i) => (i - 1 + members.length) % members.length);
  };

  const next = () => {
    setIndex((i) => (i + 1) % members.length);
  };

  const getVisible = () => {
    const arr = [];
    for (let i = 0; i < visibleCount; i++) {
      arr.push(members[(index + i) % members.length]);
    }
    return arr;
  };

  const visible = getVisible();

  return (
    <Section id="diretoria" bgClass="bg-blue-50" title="Diretoria e Conselho">
      {/* Carrossel */}
      <div className="relative max-w-6xl mx-auto mt-8 px-2 sm:px-4 md:px-8">
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={prev}
            className="flex-shrink-0 bg-navy text-white text-lg sm:text-xl md:text-2xl p-2 sm:p-2.5 rounded-full hover:bg-secondary z-20"
            aria-label="Anterior"
          >
            &#8249;
          </button>

          <div className="flex space-x-2 sm:space-x-3 md:space-x-4 justify-center flex-1 overflow-visible">
            {visible.map((m, idx) => (
              <div
                key={idx}
                className="bg-white text-navy rounded-lg flex-shrink-0 w-[180px] sm:w-56 md:w-64 lg:w-72 p-4 sm:p-4 md:p-6 text-center shadow-lg"
              >
                <div className="mx-auto w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[150px] lg:h-[150px] rounded-full overflow-hidden mb-3 sm:mb-4 bg-gray-200 flex items-center justify-center">
                  <img
                    src={process.env.PUBLIC_URL + m.img}
                    alt={m.name}
                    className="object-cover w-full h-full"
                  />
                </div>

                <h3 className="text-xs sm:text-sm md:text-[15px] font-montserrat font-bold mb-1 leading-tight">
                  {m.name}
                </h3>
                <p className="text-xs sm:text-sm md:text-[14px] font-light leading-[1.3] mb-1">
                  {m.role}
                </p>
                <p className="text-[10px] sm:text-xs md:text-[13px] font-light leading-[1.3] text-gray-600">
                  {m.term}
                </p>
              </div>
            ))}
          </div>

          <button
            onClick={next}
            className="flex-shrink-0 bg-navy text-white text-lg sm:text-xl md:text-2xl p-2 sm:p-2.5 rounded-full hover:bg-secondary z-20"
            aria-label="Próximo"
          >
            &#8250;
          </button>
        </div>
      </div>

      {/* Frase */}
      <p className="mt-8 text-center max-w-xl mx-auto italic text-sm text-navy/90">
        “Uma equipe unida pela valorização dos profissionais das agrárias e pelo
        fortalecimento do agro.”
      </p>

      {/* Comissões e Departamentos */}
      <div className="max-w-6xl mx-auto mt-14 px-4 sm:px-6">
        <div className="text-center mb-8">
          <h4 className="text-2xl sm:text-3xl font-bold text-navy">
            Estrutura Institucional
          </h4>
          <p className="text-sm sm:text-base text-gray-600 mt-2">
            Comissões e departamentos que fortalecem a atuação da AEAGO.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          <InfoGroup title="Comissões" items={commissions} />
          <InfoGroup title="Departamentos" items={departments} />
        </div>
      </div>
    </Section>
  );
};

export default Diretorias;
